import {h, Fragment} from "preact"
import { useAppState, useFacets, useProductFilters } from "@nosto/preact"
import { sortSizeData } from "../helpers"

import Facet from "./Facet"
import RangeFacet from "./RangeFacet"

export default function SideBar({ sidebarOpen, toggleSidebar, expandedFacet }) {
    const { response: { products } } = useAppState();
    const { facets } = useFacets();
    const { filters, removeAll } = useProductFilters();

    return facets?.length > 0 ? (
        <>
            <aside
                id="ns-sidebar"
                aria-expanded={sidebarOpen}
                aria-label="Filter options"
            >
                {/* HEADER */}
                <div className="ns-sidebar__header flex items-center justify-between border-b border-core-2 px-5 py-6">
                    <h3 className="text-gray-900">All Filters</h3>
                    <button
                        className="text-gray-900"
                        type="button"
                        aria-label="Close filter list"
                        onClick={toggleSidebar}
                    >
                        <svg aria-hidden="true" width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.582 2.00012L1.87213 20" stroke="currentColor" stroke-linecap="round"></path><path d="M19.8719 19.9999L2.16205 1.99997" stroke="currentColor" stroke-linecap="round"></path>
                        </svg>
                    </button>
                </div>
                
                {/* CONTENT */}
                <div className="ns-sidebar__body flex-grow overflow-scroll w-full">
                    <ul>
                        {facets?.map(facet => {
                            if(facet.data?.length > 1 && facet.type === 'terms') {
                                if(facet.name === 'Size') {
                                    sortSizeData(facet.data)
                                }
                                return (
                                    <Facet 
                                        key={facet.id} 
                                        facet={facet}
                                        expandedFacet={expandedFacet}
                                    />
                                )
                            } else if (facet.type === 'stats') {
                                return (
                                    <RangeFacet 
                                        key={facet.id} 
                                        facet={facet}
                                        expandedFacet={expandedFacet}
                                    />
                                )
                            } else {
                                return null;
                            }
                        })}
                    </ul>
                </div>

                {/* FOOTER */}
                <div className="relative bottom-0 w-full p-5 text-center bg-white shadow-[0px_-3px_8px_rgba(0,0,0,0.07)] z-1">
                    <button
                        className="button button--primary block lg:mb-2.5 w-full"
                        type="button"
                        onClick={toggleSidebar}
                    >
                        See {products?.total > 1 ? `${products.total} Results` : 'Result' }
                    </button>
                    {(filters.length > 0) && 
                        <button
                            className="lg:inline-block uppercase underline h7--medium underline-offset-8"
                            type="button"
                            aria-label="Remove all filters"
                            onClick={removeAll}
                        >
                            Clear All
                        </button>
                    }
                </div>
            </aside>

            {/* backdrop */}
            <div
                className="ns-sidebar__backdrop"
                aria-label="Close filters list"
                role="button"
                tabIndex="0"
                onClick={toggleSidebar}
            ></div>
        </>
    ) : ( null )
}
